import { onMounted, onBeforeUnmount } from 'vue'

export function useScrollReveal(containerRef, options = {}) {
  const config = { threshold: 0.20, rootMargin: '0px 0px -40px 0px', ...options }
  let observer = null

  onMounted(() => {
    const el = containerRef.value
    if (!el) return

    observer = new IntersectionObserver(
      entries => entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('visible')
          observer.unobserve(e.target)
        }
      }),
      config
    )

    el.querySelectorAll('.reveal, .reveal-mobile').forEach(el => observer.observe(el))
  })

  onBeforeUnmount(() => {
    observer?.disconnect()
  })
}
